module.exports = __webpack_public_path__ + "img/fuping.6521ba04.jpg";